import { render, staticRenderFns } from "./Shimmer.vue?vue&type=template&id=f6dd7778&scoped=true"
import script from "./Shimmer.vue?vue&type=script&lang=js"
export * from "./Shimmer.vue?vue&type=script&lang=js"
import style0 from "./Shimmer.vue?vue&type=style&index=0&id=f6dd7778&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6dd7778",
  null
  
)

export default component.exports